import React from 'react';
import { FaHeart } from 'react-icons/fa';
import './PageHeader.css';

const PageHeader = ({
  title,
  subtitle,
  icon: Icon = FaHeart,
  button
}) => {
  return (
    <div className="page-header">
      <div className="header-content">
        <div className="header-title">
          <FaHeart className="heart-icon left" />
          <h1>{title}</h1>
          <FaHeart className="heart-icon right" />
        </div>
        {subtitle && (
            <p className="header-subtitle">{subtitle}</p>
        )}
      </div>
      {button && (
        <button className="header-btn" onClick={button.onClick}>
          {button.icon && <button.icon />}
          {button.text}
        </button>
      )}
    </div>
  );
};

export default PageHeader;
